import { TreasurySectionValueDigitProps } from './TreasurySectionValueDigit.types';
import { getDigitSequence } from './TreasurySectionValue.utils';
import { css } from '@onbeam/business-styled-system/css';
import { useBreakpoint } from '@onbeam/utils';
import { motion } from 'motion/react';
import { token } from '@onbeam/business-styled-system/tokens';
import { flex } from '@onbeam/business-styled-system/patterns';

const DIGIT_HEIGHT = 70;
const MOBILE_DIGIT_HEIGHT = 56;
const INITIAL_DIGIT_COUNT = 8;

export const TreasurySectionValueDigit = ({
  value,
  index: digitIndex,
}: TreasurySectionValueDigitProps) => {
  const isDesktop = useBreakpoint({ min: token('breakpoints.sm') });
  const sequence = getDigitSequence(
    INITIAL_DIGIT_COUNT + digitIndex * 2,
    value,
  );
  const digitHeight = isDesktop ? DIGIT_HEIGHT : MOBILE_DIGIT_HEIGHT;

  return (
    <div
      className={css({
        pos: 'relative',
        height: 'var(--height)',
        overflow: 'hidden',
        maskImage:
          'linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)',
        maskSize: '100% 100%',
      })}
      style={{
        '--height': `${digitHeight}px`,
      }}
    >
      <motion.div
        className={css({
          w: '[1.4rem]',
          '@media(min-width: 360px)': {
            w: '[2rem]',
          },
          sm: {
            w: '[2.8rem]',
          },
        })}
        animate={{
          y: -digitHeight * (sequence.length - 1),
          width: 'auto',
        }}
        transition={{
          y: {
            duration: 1 + digitIndex * 0.01,
            ease: 'easeOut',
          },
          width: {
            duration: 0.9,
          },
        }}
      >
        {sequence.map((digit, index) => (
          <div
            key={index}
            className={flex({
              pos: 'absolute',
              w: 'full',
              height: 'var(--height)',
              left: '0',
              top: 'var(--top)',
              align: 'center',
              justify: 'center',
            })}
            style={{
              '--height': `${digitHeight}px`,
              '--top': `${index * digitHeight}px`,
            }}
          >
            {digit}
          </div>
        ))}
        <div className={css({ opacity: 0 })}>{value}</div>
      </motion.div>
    </div>
  );
};
